import { forwardRef, Link as ChakraLink, LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { TextSizes } from '../../types/bitkit';

export interface LinkProps extends ChakraLinkProps {
  as?: 'a' | 'button';
  colorScheme?: 'purple' | 'white' | 'gray';
  isExternal?: boolean;
  isUnderlined?: boolean;
  size?: TextSizes;
}

/**
 * Links are accessible elements used primarily for navigation.
 */
const Link = forwardRef<LinkProps, 'a'>((props, ref) => {
  const { as = 'a', isExternal, isUnderlined, ...rest } = props;
  const properties: ChakraLinkProps = { as };
  if (isExternal) {
    properties.rel = 'noreferrer noopener';
    properties.target = '_blank';
  }
  if (isUnderlined) {
    properties.textDecoration = 'underline';
  }
  if (as === 'button') {
    properties.type = 'button';
    properties.userSelect = 'text';
  }
  return <ChakraLink as={as} {...properties} {...rest} ref={ref} />;
});

export default Link;
